// This module must be rebuilt in dev mode in order for changes to take effect
import {
  getI18NOptions,
  getI18NPlugins,
  languages,
  fallbackLng,
  NAMESPACES,
  ALL_RESOURCES,
  DEFAULT_NS,
} from '@crocodille/bbdomu-i18n';

export const i18n = {
  defaultLocale: fallbackLng,
  locales: languages,
};

/** @type import('next-i18next').UserConfig */
const config = {
  i18n,
  ...getI18NOptions(),
  use: getI18NPlugins(),
  ns: NAMESPACES,
  defaultNS: DEFAULT_NS,
  //
  // If we put non-serializable data in the config, we need to disable
  // serialization and pass the config to the client manually.
  //
  serializeConfig: false,
  //
  // We don't want to cache loaded translations in dev mode.
  //
  reloadOnPrerender: process.env.NODE_ENV !== 'production',

  resources: ALL_RESOURCES,
  partialBundledLanguages: true,

  localePath: (locale, namespace) => {
    const path = require('path');
    const url = require('url');

    const file = path.resolve(
      path.dirname(url.fileURLToPath(import.meta.url)),
      `../../node_modules/@crocodille/bbdomu-i18n/resources/${namespace}.${locale}.json`,
    );

    return file;
  },
};

export default config;
